'use strict'

function _typeof(obj) {
  '@babel/helpers - typeof'
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof = function _typeof(obj) {
      return typeof obj
    }
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === 'function' &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj
    }
  }
  return _typeof(obj)
}

Object.defineProperty(exports, '__esModule', {
  value: true,
})
exports.LoaderContainer = void 0

var _react = _interopRequireWildcard(require('react'))

var _reactErrorBoundary = require('react-error-boundary')

var _reactSnackbarAlert = require('react-snackbar-alert')

var _ClipLoader = _interopRequireDefault(require('react-spinners/ClipLoader'))

var _styles = require('./styles.js')

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== 'function') return null
  var cacheBabelInterop = new WeakMap()
  var cacheNodeInterop = new WeakMap()
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop
  })(nodeInterop)
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj
  }
  if (obj === null || (_typeof(obj) !== 'object' && typeof obj !== 'function')) {
    return { default: obj }
  }
  var cache = _getRequireWildcardCache(nodeInterop)
  if (cache && cache.has(obj)) {
    return cache.get(obj)
  }
  var newObj = {}
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor
  for (var key in obj) {
    if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc)
      } else {
        newObj[key] = obj[key]
      }
    }
  }
  newObj['default'] = obj
  if (cache) {
    cache.set(obj, newObj)
  }
  return newObj
}

//	@ts-ignore
var Container = (0, _reactSnackbarAlert.wrapComponent)(function (_ref) {
  var createSnackbar = _ref.createSnackbar,
    children = _ref.children,
    error = _ref.error
  var showSnackbar = (0, _react.useCallback)(
    function () {
      var message =
        arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Something was wrong!'
      createSnackbar({
        message: message,
        dismissable: false,
        pauseOnHover: false,
        progressBar: false,
        sticky: false,
        theme: 'error',
        timeout: 3000,
      })
    },
    [createSnackbar]
  )
  ;(0, _react.useEffect)(
    function () {
      if (error && error !== '') {
        showSnackbar(error)
      }
    },
    [error, showSnackbar]
  )
  var errorFallback = (0, _react.useCallback)(
    function () {
      showSnackbar()
      return /*#__PURE__*/ _react['default'].createElement(_react['default'].Fragment, null)
    },
    [showSnackbar]
  )

  var reloadPage = function reloadPage() {
    window.location.reload()
  }

  return /*#__PURE__*/ _react['default'].createElement(
    _reactErrorBoundary.ErrorBoundary,
    {
      FallbackComponent: errorFallback,
      onReset: reloadPage,
    },
    children
  )
})

var LoaderContainer = function LoaderContainer(_ref2) {
  var children = _ref2.children,
    loading = _ref2.loading,
    error = _ref2.error,
    loadingText = _ref2.loadingText
  var renderLoader = (0, _react.useMemo)(
    function () {
      return /*#__PURE__*/ _react['default'].createElement(
        _styles.Content,
        null,
        /*#__PURE__*/ _react['default'].createElement(_ClipLoader['default'], {
          color: '#707890',
          size: 50,
          loading: loading,
        }),
        /*#__PURE__*/ _react['default'].createElement(
          _styles.Header,
          {
            className: 'fs-mask',
          },
          loadingText || 'Fetching data'
        )
      )
    },
    [loading, loadingText]
  )
  return /*#__PURE__*/ _react['default'].createElement(
    _reactSnackbarAlert.SnackbarProvider,
    {
      position: 'bottom',
    },
    /*#__PURE__*/ _react['default'].createElement(
      Container,
      {
        error: error,
      },
      loading ? renderLoader : children
    )
  )
}

exports.LoaderContainer = LoaderContainer
